import React from "react";
import Layout from "Components/Layouts/Common/common";
import AboutClasses from "./styles.module.css";
import About3 from "Assets/About/about_3.png";
import Image1 from "Assets/About/about_1.png";
import About_2 from "Assets/About/about_2.png";
import AboutCard from "Components/AboutUs/Cards/Cards";
function About() {
    return (
        <Layout>
            <div className={AboutClasses["Container"]}>
                <header>
                    <h3>Business Tax returns</h3>
                </header>

                <div className={AboutClasses["section-1"]}>
                    <div className={AboutClasses["content"]}>
                        <h3>
                            Running a business is complex—let Serene Tax handle
                            your business tax returns so you can focus on
                            growing your company.
                        </h3>
                        <p>
                            At Serene Tax, we provide expert tax preparation and
                            filing services for businesses of all sizes. Whether
                            you're a sole proprietor, LLC, partnership,
                            S-corporation, or C-corporation, our team has the
                            experience and knowledge to ensure your business tax
                            returns are filed accurately, on time, and in
                            compliance with all applicable laws.
                        </p>
                    </div>
                    <img src={Image1} alt="user" />
                </div>

                <div
                    className={`${AboutClasses["section-1"]} ${AboutClasses["section-2"]}`}>
                    <img src={About_2} alt="user" />
                    <div className={AboutClasses["content"]}>
                        {/* <h5>Who we are</h5>{" "} */}
                        <h3>
                            Why File Your Business Tax Return with Serene Tax?
                        </h3>
                        <p>
                            <b>Expert Tax Preparation:</b> Our tax professionals
                            specialize in business tax returns and understand
                            the unique requirements for different business
                            structures. We’ll ensure your return is optimized
                            for deductions, credits, and tax-saving
                            opportunities
                        </p>
                        <p>
                            <b>Minimize Tax Liabilities:</b> With our thorough
                            understanding of tax laws, we help you take full
                            advantage of all available tax deductions and
                            credits, potentially reducing your overall tax
                            burden.
                        </p>
                        <p>
                            <b>Timely Filing:</b> We understand the importance
                            of meeting deadlines and ensuring that your taxes
                            are filed on time to avoid late fees, penalties, and
                            interest. We manage the entire process to ensure
                            timely filing.
                        </p>
                        <h4>Comprehensive Services for All Business Types:</h4>
                        <ul>
                            <li>Sole Proprietorships</li>
                            <li>Partnerships</li>
                            <li>Limited Liability Companies (LLC)</li>
                            <li>S-Corporations</li>
                            <li>C-Corporations</li>
                        </ul>
                        <p>
                            <b>Audit Protection:</b> We provide thorough
                            documentation and explanations to reduce the risk of
                            IRS audits. If your business is audited, Serene Tax
                            is here to represent you and guide you through the
                            process.
                        </p>
                    </div>
                </div>
                <div className={AboutClasses["section-1"]}>
                    <div
                        className={AboutClasses["content"]}
                        style={{ gap: "0.6rem" }}>
                        <h3>What We Do for Your Business Tax Return ?</h3>
                        <p>
                            <b> 1.Tax Preparation and Filing:</b>
                            We handle all aspects of tax preparation, from
                            gathering financial information to completing the
                            necessary forms and submitting them on time. Whether
                            you're filing Form 1065, Form 1120, Form 1120S, or
                            another business tax form, we ensure the correct
                            forms are filed for your specific business type.
                        </p>
                        <p>
                            <b>2.Maximize Deductions and Credits:</b>
                            We work closely with you to identify all eligible
                            business deductions—whether it's for operational
                            expenses, employee salaries, business equipment, or
                            more. This helps reduce your taxable income and
                            potentially lowers your tax liability.
                        </p>
                        <p>
                            <b>3.Tax Planning:</b>
                            Our team provides strategic tax planning services
                            throughout the year, not just at tax time. We’ll
                            help you make decisions that benefit your bottom
                            line, whether it's tax-advantaged retirement
                            planning, structuring your business for tax
                            efficiency, or managing business expenses.
                        </p>
                        <p>
                            <b>4.State and Local Tax Compliance:</b>
                            In addition to federal taxes, we ensure that your
                            business complies with state and local tax
                            regulations. We assist with sales tax, payroll tax,
                            and any other local business requirements, ensuring
                            full compliance with tax laws in your area.
                        </p>
                    </div>
                    <img src={About3} alt="user" />
                </div>
                <div
                    className={`${AboutClasses["section-1"]} ${AboutClasses["section-2"]}`}>
                    <img src={About3} alt="user" />
                    <div
                        className={AboutClasses["content"]}
                        style={{ gap: "0.6rem" }}>
                        <h3>Business Tax Structures We Specialize In</h3>
                        <ul>
                            <li>
                                <b>Sole Proprietorships:</b>As a solo business
                                owner, your tax return will be filed through
                                Schedule C. We help you file accurately and
                                ensure you claim all eligible deductions.
                            </li>
                            <li>
                                <b>Partnerships</b>: We handle the preparation
                                of Form 1065, including Schedule K-1s for each
                                partner, ensuring your partnership's income,
                                deductions, and credits are reported correctly.
                            </li>
                            <li>
                                <b>LLCs</b>: Whether taxed as a sole
                                proprietorship, partnership, or corporation, we
                                help you navigate the unique tax requirements of
                                LLCs to ensure compliance and reduce liabilities
                            </li>
                            <li>
                                <b>S-Corporations: </b>We assist with filing
                                Form 1120S for S-corporations and provide advice
                                on how to distribute income to avoid unnecessary
                                taxes.
                            </li>
                            <li>
                                <b>C-Corporations:</b> Our experts handle Form
                                1120 filings for C-corporations, ensuring your
                                corporate tax return is optimized to minimize
                                tax liability and avoid penalties.
                            </li>
                        </ul>
                    </div>
                </div>
                <div className={AboutClasses["section-1"]}>
                    <div
                        className={AboutClasses["content"]}
                        style={{ gap: "0.6rem" }}>
                        <h3>The Business Tax Filing Process</h3>
                        <p>
                            <b>1.Initial Consultation:</b>
                            <br />
                            We’ll meet with you to discuss your business
                            structure, financials, and tax situation. This
                            allows us to understand your needs and ensure that
                            all relevant tax information is gathered.
                        </p>
                        <p>
                            <b>2.Gather Financial Data:</b>
                            We assist you in collecting the necessary
                            documentation, such as income statements, balance
                            sheets, receipts, and payroll records.
                        </p>
                        <p>
                            <b>3.Tax Filing:</b>
                            After completing your tax forms, we review
                            everything thoroughly to ensure accuracy before
                            submitting it to the IRS or relevant state
                            authorities.
                        </p>
                        <p>
                            <b>4.Ongoing Support:</b>
                            We don't just file your taxes—we provide ongoing
                            support throughout the year, including tax planning
                            and advisory services, ensuring your business stays
                            on track financially and taxefficiently
                        </p>
                    </div>
                    <img src={About3} alt="user" />
                </div>
                <div
                    className={`${AboutClasses["section-1"]} ${AboutClasses["section-2"]}`}>
                    <img src={About3} alt="user" />
                    <div
                        className={AboutClasses["content"]}
                        style={{ gap: "0.6rem" }}>
                        <h3>
                            Common Business Tax Deductions We Help You Claim
                        </h3>
                        <ul>
                            <li>Employee Salaries and Wages</li>
                            <li>
                                Operating Expenses (e.g., rent, utilities,
                                office supplies)
                            </li>
                            <li>Home Office Deduction</li>
                            <li>Business Travel and Meals</li>
                            <li>Depreciation of Assets</li>
                            <li>Interest on Business Loans</li>
                            <li>Advertising and Marketing</li>
                            <li>Professional Fees (e.g., legal, accounting)</li>
                            <li>Insurance Premiums</li>
                        </ul>
                    </div>
                </div>
                <div className={AboutClasses["section-1"]}>
                    <div
                        className={AboutClasses["content"]}
                        style={{ gap: "0.6rem" }}>
                        <h3>
                            Why Choose Serene Tax for Your Business Tax Returns?
                        </h3>
                        <p>
                            <b>Experienced Tax Professionals:</b> Our team is up
                            to date on the latest tax laws and changes, ensuring
                            your business benefits from the most current
                            tax-saving strategies.
                        </p>
                        <p>
                            <b>Personalized Service: </b>We provide tailored tax
                            strategies that fit the unique needs of your
                            business.
                        </p>
                        <p>
                            <b>Timely Filing:</b>
                            We ensure that all business tax returns are filed on
                            time, avoiding penalties and keeping your business
                            in compliance.
                        </p>
                        <p>
                            <b>Audit Support:</b>
                            If your business is selected for an IRS audit, we
                            provide full support, including representation to
                            help resolve any issues.
                        </p>
                        <p>
                            <b>Comprehensive Tax Solutions: </b>
                            From tax planning to filing and beyond, we offer
                            fullservice support to help your business thrive.
                        </p>
                    </div>
                    <img src={About3} alt="user" />
                </div>
                <div
                    className={AboutClasses["section-1"]}
                    style={{ gridTemplateColumns: "1fr" }}>
                    <div
                        className={AboutClasses["content"]}
                        style={{ gap: "0.6rem" }}>
                        <h3>Get Started with Serene Tax Today</h3>
                        <p>
                            Running a business is challenging enough—let Serene
                            Tax handle your tax preparation, so you can focus on
                            growing your business. We’re here to make the tax
                            filing process seamless and stress-free.
                            <br />
                            Contact us today for a consultation.{" "}
                            <b>Call [+1 (262) 735-8874/ +1 (262) 735- 8875]</b>
                        </p>
                    </div>
                </div>
            </div>
        </Layout>
    );
}

export default About;
